import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { getFunctionsInstance } from '@zealth/core/firebase/runtime'
import { httpsCallable } from 'firebase/functions'

import { type InsightsEnv, type InsightsPanels } from './panels'

export const INSIGHTS_PAYLOAD_QUERY_KEY = ['insights', 'payload'] as const

/**
 * Mirrors `GetInsightsPayloadResponse` in functions/src/insights. Declared on each
 * side, like every playground callable (see adviserRoleApi.ts there) — no
 * shared module.
 */
export interface InsightsPayload {
  env: InsightsEnv
  /** `generated_at` of the payload table, ISO 8601 — the as-of on screen. */
  generatedAt: string
  panels: InsightsPanels
}

/**
 * The dashboard's one read. `getInsightsPayload` rejects every caller without
 * the insights or admin claim, strips team_accounts for non-admins, and refuses
 * a payload that names anyone elsewhere.
 */
export const useInsightsPayload = (): UseQueryResult<InsightsPayload> =>
  useQuery({
    queryKey: INSIGHTS_PAYLOAD_QUERY_KEY,
    queryFn: async () => {
      const call = httpsCallable<void, InsightsPayload>(
        getFunctionsInstance(),
        'getInsightsPayload'
      )
      return (await call()).data
    },
    staleTime: Infinity,
    retry: false,
  })
